import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

import { IModalMessages } from '../../../types';

import { styles } from './SharePublication.styles';

export type ISharePublicationProps = {
  messages: IModalMessages;
  open: boolean;
  isLoading: boolean;
  onClose(): void;
  onConfirm(): void;
}

export const SharePublication = ({ open, onClose, onConfirm, isLoading, messages }: ISharePublicationProps) => {
  if (!open) return null;

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm" data-test="dialog-share-publication" PaperProps={{ sx: styles.dialogPaper, 'data-test': 'dialog-share-publication-container' }} aria-labelledby="dialogTitle">
      <DialogTitle id="dialogTitle" sx={styles.dialogTitle}>
        {messages.sharePublication}
        <IconButton aria-label="close" onClick={onClose} size="small" sx={styles.closeButton} data-test="dialog-share-publication-close-button">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Typography variant="body2" className="dialog-description">{messages.shareDescription}</Typography>
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button variant="outlined" color="secondary" size="small" onClick={onClose} data-test="cancel-share-publication">
          {messages.cancel}
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          size="small"
          loading={isLoading}
          onClick={onConfirm}
          data-test="generate-link"
        >
          {messages.generateLink}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
